/*
  Keeps the price and stock line inside the add-to-cart button in sync when the
  shopper changes variant.

  product-variants.js re-renders only a fixed set of ids (price, Inventory, Sku,
  ProductPurchaseInfo, ProductStickyCart) and otherwise just toggles the submit
  button's disabled state, so the button's own price/stock markup would go stale
  on its own. It does publish variantChange with the freshly fetched document,
  which is what this reads from.
*/
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  var SELECTORS = ['[data-atc-price]', '[data-atc-stock]'];

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = event && event.data;
    if (!data || !data.html || !data.sectionId) return;

    var button = document.getElementById('ProductSubmitButton-' + data.sectionId);
    var source = data.html.getElementById('ProductSubmitButton-' + data.sectionId);
    if (!button || !source) return;

    SELECTORS.forEach(function (selector) {
      var destination = button.querySelector(selector);
      var origin = source.querySelector(selector);
      if (!destination || !origin) return;

      destination.innerHTML = origin.innerHTML;
      // Carries the sold-out modifier across so the dot matches availability.
      destination.className = origin.className;
    });
  });
})();
